function formatData(originData, role) {
  let data = {};

  if(role === 'team') {
    data.maxAvgAccuracy = originData.maxAvgAccuracy
    data.maxAvgDamage = originData.maxAvgDamage
    data.maxAvgKill = originData.maxAvgKill
    data.maxAvgSurvivalTime = originData.maxAvgSurviveTime
    data.maxAvgTravelDistance = originData.maxAvgTotalDistance

    data.name = originData.name
    data.seasonId = originData.seasonId

    data.subAvgAccuracy = originData.teamAvgAccuracy
    data.subAvgDamage = originData.teamAvgDamage
    data.subAvgKill = originData.teamAvgKill
    data.subAvgSurvivalTime = originData.teamAvgSurviveTime
    data.subAvgTravelDistance = originData.teamAvgTravelDistance

    data.totalAvgAccuracy = originData.totalAvgAccuracy
    data.totalAvgDamage = originData.totalAvgDamage
    data.totalAvgKill = originData.totalAvgKill
    data.totalAvgSurvivalTime = originData.totalAvgSurviveTime
    data.totalAvgTravelDistance = originData.totalAvgTravelDistance
  }else if(role === 'star') {
    data.maxAvgAccuracy = originData.maxAvgAccuracy
    data.maxAvgDamage = originData.maxAvgDamage
    data.maxAvgKill = originData.maxAvgKill
    data.maxAvgSurvivalTime = originData.maxAvgSurviveTime
    data.maxAvgTravelDistance = originData.maxAvgTotalDistance

    data.name = originData.name 
    data.seasonId = originData.seasonId

    data.subAvgAccuracy = originData.avgAccuracy
    data.subAvgDamage = originData.avgDamage
    data.subAvgKill = originData.avgKill
    data.subAvgSurvivalTime = originData.avgSurviveTime
    data.subAvgTravelDistance = originData.avgTotalDistance

    data.totalAvgAccuracy = originData.allAvgAccuracy
    data.totalAvgDamage = originData.allAvgDamage
    data.totalAvgKill = originData.allAvgKill
    data.totalAvgSurvivalTime = originData.allAvgSurviveTime
    data.totalAvgTravelDistance = originData.allAvgTotalDistance
  }

  return data;
}


function getOption(chartDom, type) {
  let fontScale = chartDom.offsetHeight / 274;

  let labelColor = {
    avg: { name: "平均值", color: "#E0BE80" },
    team: { name: type === 'team' ? "战队值" : '选手值', color: "#E74747" },
  };

  const option = {
    legend: {
      top: `${3 * fontScale}%`,
      right: `${3 * fontScale}%`,
      itemWidth: 18 * fontScale,
      itemHeight: 18 * fontScale,
      orient: "vertical",
      itemGap: 10 * fontScale,
      data: [
        {
          name: labelColor.avg.name,
          icon: "rect",
          itemStyle: {
            color: labelColor.avg.color,
            opacity: 1,
          },
        },
        {
          name: labelColor.team.name,
          icon: "rect",
          itemStyle: {
            color: labelColor.team.color,
            opacity: 0.8,
          },
        },
      ],
      textStyle: {
        fontSize: 18 * fontScale,
      },
    },
    radar: {
      radius: ["0%", "55%"],
      center: ["50%", "55%"],
      indicator: [
        { name: "场均淘汰", max: 0 },
        { name: "命中率", max: 0 },
        { name: "场均存活时长", max: 0 },
        { name: "场均位移距离", max: 100 },
        { name: "场均伤害", max: 0 },
      ],
      splitNumber: 2,
      name: {
        formatter: ["{a|-}", "{b|{value}}"].join("\n"),
        textStyle: {
          width: 200 * fontScale,
          height: 30 * fontScale,
          color: "#807979",
          padding: [-10, -10, 0, -10],
        },
        rich: {
          a: {
            fontSize: 38 * fontScale,
            lineHeight: 30 * fontScale,
            fontWeight: "bolder",
            fontFamily: "NumFont",
            align: "center",
          },
          b: {
            fontSize: 18 * fontScale,
            lineHeight: 25 * fontScale,
            fontFamily: "Noto Sans SC",
            align: "center",
          },
        },
      },
      splitArea: {
        areaStyle: {
          color: ["rgba(255, 196, 194, 0.2)", "rgba(255, 196, 194, 0.2)", "rgba(255, 196, 194, 0.2)"],
        },
      },
      axisLine: {
        lineStyle: {
          color: "#660307",
        },
      },
      splitLine: {
        lineStyle: {
          color: "#660307",
        },
      },
    },
    series: [
      {
        type: "radar",
        symbolSize: 0,
        silent: true,
        data: [
          {
            value: [],
            name: labelColor.avg.name,
            areaStyle: {
              color: labelColor.avg.color,
              opacity: 0.5,
            },
            lineStyle: {
              width: 0,
            },
          },
          {
            value: [],
            name: labelColor.team.name,
            areaStyle: {
              color: labelColor.team.color,
              opacity: 0.8,
            },
            lineStyle: {
              width: 1,
              color: "#D00202",
            },
          },
        ],
      },
    ],
  };

  return option;
}


function updataOption(originData, o, role) {
  let data = formatData(originData, role)
  let option = o;

  // 每个属性的位置，固定
  let totalMax = [
      Math.round(data.maxAvgKill), // 场均淘汰
      Math.round(data.maxAvgAccuracy), // 命中率
      Math.round(data.maxAvgSurvivalTime), // 场均存活时长
      Math.round(data.maxAvgTravelDistance), // 场均位移距离
      Math.round(data.maxAvgDamage), // 场均伤害
    ],
    totalAvg = [
      Math.round(data.totalAvgKill),
      Math.round(data.totalAvgAccuracy),
      Math.round(data.totalAvgSurvivalTime),
      Math.round(data.totalAvgTravelDistance),
      Math.round(data.totalAvgDamage),
    ],
    sub = [
      Math.round(data.subAvgKill),
      Math.round(data.subAvgAccuracy),
      Math.round(data.subAvgSurvivalTime),
      Math.round(data.subAvgTravelDistance),
      Math.round(data.subAvgDamage),
    ];

  let indicator = [
    { name: [sub[0], "场均淘汰"], max: totalMax[0] },
    { name: [`${sub[1]}%`, "命中率"], max: totalMax[1] },
    {
      name: [
        `${Math.floor(sub[2] / 60)}m${sub[2] % 60}s`,
        "场均存活时长",
      ],
      max: totalMax[2],
    },
    {
      name: [`${(sub[3] / 1000).toFixed(2)}km`, "场均位移距离"],
      max: totalMax[3],
    },
    { name: [sub[4], "场均伤害"], max: totalMax[4] },
  ];

  let formatter = function (value) {
    let formated = [`{a|${value[0]}}`, `{b|${value[1]}}`].join("\n");
    return formated;
  };

  option.radar.indicator = indicator;
  option.radar.name.formatter = formatter;
  option.series[0].data[0].value = totalAvg;
  option.series[0].data[1].value = sub;

  return option;
}


export {
  getOption,
  updataOption
}